import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/useAuth';
import { Button } from './Button';
import { rememberPath } from '../lib/keepSignedIn';
import { countPendingCandidates } from '../features/review/api';
import logo from '../assets/lockup-horizontal.svg';

const LINKS = [
  { to: '/equipment', label: 'Equipment' },
  { to: '/exercises', label: 'Exercises' },
  { to: '/review', label: 'Review' },
  { to: '/covers', label: 'Covers' },
  { to: '/admins', label: 'Admins' },
];

export function Layout() {
  const { user, signOut } = useAuth();
  const location = useLocation();
  const [pendingCount, setPendingCount] = useState<number | null>(null);
  // Remember where you are (filters included) so the next visit opens here.
  useEffect(() => {
    rememberPath(location.pathname + location.search);
  }, [location.pathname, location.search]);
  useEffect(() => {
    countPendingCandidates().then(setPendingCount).catch(() => setPendingCount(null));
  }, [location.pathname]);
  return (
    <div className="layout">
      <nav className="sidebar">
        <div className="brand">
          <img src={logo} alt="Calyard" />
          <div className="muted" style={{ marginTop: 6 }}>
            Admin
          </div>
        </div>
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            {l.label}
            {l.to === '/review' && pendingCount ? <span className="nav-badge">{pendingCount}</span> : null}
          </NavLink>
        ))}
        <div style={{ marginTop: 'auto', paddingTop: 20 }}>
          <div className="muted" style={{ padding: '0 14px 8px' }}>
            {user?.email}
          </div>
          <Button tone="neutral" size="sm" onClick={() => signOut()} style={{ width: '100%' }}>
            Sign out
          </Button>
        </div>
      </nav>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
